/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

Odigeo.defineWidget('membership_login_feedback', Odigeo.Widget.extend({
    viewClass: require('./view'),

    openLightBox: function(userName) {
        this.view.renderLoginFeedback(userName);
    },
}));
